import { APP_CONFIG } from './app.config';

export const ApiBaseUrl = APP_CONFIG.apiBaseUrl;
export const TokenUrl = APP_CONFIG.tokenApiUrl;

export const ROUTER_CONFIG = {
  notFound: '404',
  forbidden: '403',
  auth: {
    login: 'login',
  },
  home: 'home',
  download: 'download',
};

export const NavigateRouting = {
  Main: 'main',
  Admin: 'admin',
  ChooseCompany: 'choose-company',
  BackToLoginAdmin: 'admin/login',
  ChooseDai: 'choose-dai',
  BackToLogin: 'login',
  Stream: 'stream',
  MessageRelative: 'message-relative',
  RecordList: 'record-list',
  RecordGraph: 'record-graph',
  Participant: 'participant',
  NotPublic: 'not-public',
  RoleRegistration: 'role-registration',
  ChooseRole: 'choose-role',
  Apply: 'control/apply',
  Control: 'control',
  AccountInformation: 'account-information',
  AccountInformationParticipant: 'participant/account-information',
  DaiAccountInformation: 'dai-account-information',
  DaiAccountInformationParticipant: 'participant/dai-account-information',
  TermsUse: 'terms-use',
  TermsUseUnUserCareKarte: 'terms-use-unuser-carekarte',
  Planning: 'planning',
  DaiRelative: 'dai-relative',
  Home: 'home',
  Help: 'help',
  UserInfManagement: 'user-inf-management',
  ConfirmAgreePlan: 'confirm-agree-plan',
  ConsentRegistration: 'consent-registration',
  CompanyAnnouncement: 'company-announcement',
  ControlCompanyAnnouncementCreate: 'control/company-announcement/create',
  ControlCompanyAnnouncementUpdate: 'control/company-announcement/update',
  PdfViewerPost: 'pdf-viewer/post',
  LockAccount: 'lock-account',
  TermsUseVersion: 'terms-use/version',
  QRCodeInvitation: 'qr-code-invitation',
  MassQRCodeInvite: 'mass-qr-code-invitation',
  ConsenterManagement: 'consenter-management',
  ChangingConsenter: 'changing-consenter',
  RegisterConsenterAsDai: 'register-consenter-as-dai',
  RegisterConsenterAsRelative: 'register-consenter-as-relative',
  EditRelativeNoPass: 'edit-relative-no-pass',
  DeleteDaiRelated: 'delete-dai-related',
  RegisterTemp: 'register-temp',
  ChangingDaiRelatedConsenter: 'changing-dai-related-consenter',
  BasicInformationRelated: 'basic-information/related',
  BasicInformationQRCode: 'basic-information/qr-code',
  BasicInformationApply: 'basic-information/apply',
  ConsentSettings: 'consent/settings',
  ConsentConfirmAgree: 'consent/confirm-agree',
  Announcement: 'announcement',
  RecordManagementRecordList: 'record-management/record-list',
  RecordManagementRecordGraph: 'record-management/record-graph',
  RecordManagementDisplaySettings: 'record-management/display-settings',
  RecordManagementPreview: 'record-management/preview',
  ClaimBillingSettings: 'claim/billing-settings',
  ClaimDisplaySettings: 'claim/display-settings',
  ClaimPreview: 'claim/preview',
  VideoCall: 'video-call',
  StaffManagement: 'staff-management',
  MenuSettingsLive: 'menu-settings/live',
  MenuSettingsControl: 'menu-settings/control',
  ChangeCompany: 'change-company',
  HelpManagement: 'help-management',
  AccountManagement: 'account-management',
  Blank: 'blank',
};

export const ApiApplication = {
  Relative: {
    controller: ApiBaseUrl + 'relative',
    getRelative: 'get-relative',
    getDaiRelated: 'get-dai-related',
    reSendNotification: 're-notify',
    getRelativeConsenterSettings: 'get-relative-consenter-settings',
  },
  STREAM: {
    getRelative: ApiBaseUrl + 'user-relative/get-by-relative-id/',
  },
  Auth: {
    loginByCKPass: ApiBaseUrl + 'auth/login',
    getUserByToken: ApiBaseUrl + 'auth/get-user-by-token',
    refreshToken: TokenUrl + 'ck-pass/token/refresh',
    verifyRefreshToken: TokenUrl + 'ck-pass/token/verify-refresh-token',
    logout: TokenUrl + 'token/logout',
  },
  DAI_LIST: {
    controller: ApiBaseUrl + 'dai-public',
    getPublicDate: ApiBaseUrl + 'dai-public/public-date',
    insertOrUpdateOne: ApiBaseUrl + 'dai-public/insert-update-one',
    deleteDaiPublic: ApiBaseUrl + 'dai-public/',
    bulkPublish: ApiBaseUrl + 'dai-public/bulk-publish',
    bulkUnpublish: ApiBaseUrl + 'dai-public/bulk-unpublish',
  },
  USER_LIST: {
    create: ApiBaseUrl + 'user-inf/create',
    update: ApiBaseUrl + 'user-inf/update/',
    delete: ApiBaseUrl + 'user-inf/delete/',
    getByCompanyId: ApiBaseUrl + 'user-inf/get-by-company-id/',
  },
  DAI_RELATIVE: {
    controller: ApiBaseUrl + 'dai-relative/',
    DELETE_DAI: ApiBaseUrl + 'dai-relative/delete-dai',
    CONSENT_REGISTRATION_WITH_PASS_ACCOUNT: ApiBaseUrl + 'dai-relative/consent-registration-with-pass-account',
    CONSENT_REGISTRATION: ApiBaseUrl + 'dai-relative/consent-registration',
    GET_CONSENT_LIST: ApiBaseUrl + 'dai-relative/get-consent-list',
    GET_INFO_BY_CODE: ApiBaseUrl + 'dai-relative/get-info-by-code',
  },
  DAI_PUBLIC: {
    controller: ApiBaseUrl + 'dai-public/',
    DAI_LIST: 'get-dai-list',
    DAI_BY_DAICD: 'get-dai-by-daicds',
    NOTE_LIST: 'get-note-list',
    NOTE_GRAPH_LIST: 'get-note-graph-list',
    NOTE_LIST_BY_SELECTED_DATE: 'get-note-list-by-selected-date',
    RESET_DATA_BY_DAI_SELECTED: 'reset-data-by-dai-selected',
    RESET_DATA_RECORD_LIST: 'reset-data-record-list',
    TITLE_TAG_DATA_BY_SELECTED_DATE: 'get-title-tag-data-by-selected-date',
    GET_LIST_DAI_BY_ROLE: 'get-dai-by-role',
    UPDATE_STEP_FUNCTION_BY_DAICD: 'update-step-function-by-daicd',
    NOTE_LIST_STEP_FUNCTION: 'get-note-list-sf',
    GET_ID_STEP_FUNCTION_BY_DAICD: 'get-id-step-function-by-daicd',
    DOWNLOAD_IMAGE_FROM_S3: 'download-image-from-s3',
  },
  APPLY: {
    controller: ApiBaseUrl + 'apply',
    getAll: 'get-all',
    approve: 'approve',
    delete: 'delete',
  },
  DAI_QR_CODE: {
    controller: ApiBaseUrl + 'dai-qr-code/',
    bulkCreateQRCode: 'bulk-create-qr-code',
  },
  PARTICIPANT_COMPANY: {
    controller: ApiBaseUrl + 'participant-company',
    getAll: '/get-all',
  },
  PARTICIPANT: {
    CONTROLLER: ApiBaseUrl + 'participant/',
    RE_SEND_NOTIFICATION: 're-notify',
    GET_BY_USER: ApiBaseUrl + 'participant/get-by-user',
  },
  MST_MESSAGE: {
    CONTROLLER: ApiBaseUrl + 'mst-message/',
    GET_ALL: 'get-all/',
    GET_BY_IDS: 'get-by-ids/',
  },
  ROLE_REGISTRATION: {
    CONTROLLER: ApiBaseUrl + 'role-registration/',
    PRE_CHECK: 'pre-check/',
    UPDATE: ApiBaseUrl + 'role-registration/update',
  },
  USER_ROLE: {
    CONTROLLER: ApiBaseUrl + 'user-role/',
    GET_STAFF_LIST: 'get-staff-list/',
    DELETE_STAFF: 'delete-staff/',
    GET_BY_ID: 'get-all-by-id/',
    COUNT_SYS_ADMIN: 'count-sys-admin/',
    CHANGE_USER_ROLE: 'change-staff-role/',
    GET_STF_CD: 'get-stf-cd',
  },
  INVITE_STAFF: {
    CONTROLLER: ApiBaseUrl + 'invite-staff/',
    GET_INVITED_LIST: 'get-invited-list/',
    DELETE: 'delete/',
    UPDATE_MEMO: 'update-memo/',
    SEND_INVITATION: 'send-invitation/',
    SEND_INVITATION_AGAIN: 'send-invitation-again/',
  },
  PERMISSION: {
    CONTROLLER: ApiBaseUrl + 'permission/',
    GET_ALL: 'get-all',
    DETAILS: ApiBaseUrl + 'permission-details/',
    UPDATE: 'update',
    GET_RP_PERMISSION: 'get-rp-permission',
    UPDATE_RP: 'update-rp',
  },
  COMPANY_ROLE: {
    CONTROLLER: ApiBaseUrl + 'company-role/',
    GET_PERMISSION: 'get-permission',
    GET_RP_PERMISSION: 'get-rp-permission',
  },
  ACCOUNT_INFORMATION: {
    CONTROLLER: ApiBaseUrl + 'account-information/',
    GET_BY_IDS: 'get-user-by-ids/',
  },
  TTL_MST: {
    CONTROLLER: ApiBaseUrl + 'ttl-mst/',
    TITLE_TAG_MASTER_LIST: 'get-title-tag-master-list',
    TITLE_MST_REFRESH: 'create-update-data',
    TITLE_MST_CK: 'get-ck-title-tag-master-list',
    TITLE_SETTING: 'get-title-setting',
  },
  GRAPH_TTL_MST: {
    CONTROLLER: ApiBaseUrl + 'graph-ttl-mst/',
    GRAPH_TITLE_TAG_MASTER_LIST: 'get-graph-title-tag-master-list',
    GRAPH_TITLE_TAG_MASTER_IN_LIVE_LIST: 'get-graph-title-tag-master-in-live-list',
  },
  GRAPH_TITLE: {
    CONTROLLER: ApiBaseUrl + 'graph-title/',
    GRAPH_TITLE_TAG_LIST: 'get-graph-title-tag-list',
    UPDATE_GRAPH_XML: 'update-graph-xml',
  },
  CONSENT: {
    CONTROLLER: ApiBaseUrl + 'consent/',
    CHECK: 'check/',
    CREATE: 'create/',
    GET_LATEST_VERSION: 'get-latest-version/',
  },
  USAGE_LOG: {
    GET_LOG: ApiBaseUrl + 'logs',
    BULK_LOG: ApiBaseUrl + 'logs/bulk',
  },
  HELP: {
    CONTROLLER: ApiBaseUrl + 'help/',
    GET_ALL: 'get-all/',
    GET_LIST_HELP_POPUP: 'get-list-help-popup/',
  },
  HELP_DETAIL: {
    CONTROLLER: ApiBaseUrl + 'help-detail/',
    ADD: 'add/',
  },
  POST: {
    CONTROLLER: ApiBaseUrl + 'post/',
    GET_ALL: 'get-all/',
    GET_ALL_BY_ROLE: 'get-all-by-role/',
    GET_DETAIL: 'get-detail/',
    GET_PDF: 'get-pdf/',
    CREATE_POST: 'create-post/',
    CREATE_DRAFT_POST: 'create-draft-post/',
    UPDATE_POST: 'update/',
    DELETE_POST: 'delete/',
    PUBLISHED_POST: 'published/',
    GET_ATTACHMENT_POST: 'get-attachment/',
    GET_CONTROL_POST: 'get-control-post/',
    GET_LATEST_POST_INFO: 'get-latest-post-info/',
  },
  POST_DETAIL: {
    CONTROLLER: ApiBaseUrl + 'post-detail/',
    CREATE: 'create/',
  },
  LOGIN_NOTICE: {
    CONTROLLER: ApiBaseUrl + 'login-notice/',
    GET_CURRENT: 'get-current/',
  },
  LIVE_COMPANY: {
    CONTROLLER: ApiBaseUrl + 'live-company',
    GET_STATUS_TUTORIAL: 'get-status-tutorial',
    UPDATE_STATUS_TUTORIAL: 'update-status-tutorial',
    GET_STATUS_UPDATE_XML: 'get-status-update-xml',
    GET_INFOSENT_AVAILABILITY: 'get-infosent-availability',
    DELETE_PLAN: 'delete-plan',
    UPDATE_STEP_FUNCTION_BY_COMPANYID: 'update-step-function-by-companyid',
    GET_ID_STEP_FUNCTION_BY_COMPANYID: 'get-id-step-function-by-companyid',
  },
  REGISTER_TEMP: {
    CONTROLLER: ApiBaseUrl + 'register-temp',
    VERIFY_CONTACT_METHOD: 'verify-contact-method',
    ADD_RELATIONSHIP: 'add-relationship',
    REGISTER_TEMP: 'register-temp',
    CONFIRMATION: 'confirmation',
    DAI_PASS_CHECKING: 'dai-pass-checking',
    CHECK_BEFORE_REREGISTRATION: 'check-before-reregistration',
    REREGISTRATION: 'reregistration',
  },
  CONSENTER_MANAGEMENT: {
    CONTROLLER: ApiBaseUrl + 'consenter-management',
    CHECK_CREATE_AS_DAI_SELF_CARE: 'check-create-consenter-as-dai-self-care',
    CHECK_CREATE_AS_RELATIVE: 'check-create-consenter-as-relative',
    CREATE_CONSENTER_AS_DAI_SELF_CARE: 'create-consenter-as-dai-self-care',
    CREATE_CONSENTER_AS_RELATIVE: 'create-consenter-as-relative',
    CHANGING_CONSENTER: 'changing-consenter',
    UPDATE_RELATIVE_NO_PASS: 'update-consenter-relative-no-pass',
    DELETE_RELATIVE_NO_PASS: 'delete-consenter-relative-no-pass',
    GET_ACCESS_KEY: 'get-access-key/',
    GET_NO_PASS_CONSENTER_BY_ID: 'get-no-pass-consenter-by-id',
  },
  VIDEO_CALL: {
    CONTROLLER: ApiBaseUrl + 'video-call/',
    PERMISSION: 'permission',
    SKYWAY_TOKEN: 'skyway-token',
  },
  DAI: {
    CONTROLLER: ApiBaseUrl + 'dai/',
    GET_DAI_INFO_BY_ID: 'get-dai-info-by-id',
  },
  CARECONNE_INFO: {
    CONTROLLER: ApiBaseUrl + 'careconne-info/',
    GET_FILE: 'get-file',
  },
};
